import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { DateString } from '@sdk/types';

import { useImportToastShifts } from './ImportToastShiftsDropdown.hooks';
import { Label } from './ImportToastShiftsDropdown.styles';

type Props = {
  date: DateString;
  currentUser: AuthUserType;
  displayMode: string;
  importsDisabled: boolean;
};

const ImportToastShiftsDropdown = ({ date, displayMode, currentUser, importsDisabled }: Props) => {
  const importToastShifts = useImportToastShifts(date, displayMode, currentUser);

  return (
    <Label disabled={importsDisabled} onClick={importToastShifts}>
      Import shifts from Toast
    </Label>
  );
};

export default {
  ReactComponent: ImportToastShiftsDropdown,
  bindings: {
    date: '<',
    displayMode: '<',
    currentUser: '<',
    importsDisabled: '<',
  },
};
